ace.define("ace/theme/sashido",["require","exports","module","ace/lib/dom"], function(acequire, exports, module) {

exports.isDark = false;
exports.cssClass = "ace-sashido";
exports.cssText = "\
.ace-sashido {\
background: #fff;\
font-family: 'Source Code Pro', 'Courier New', monospace;\
font-size: 14px;\
line-height: 18px;\
}\
.ace-sashido .ace_gutter {\
background: #fff;\
color: #a3a3c2;\
font-size: 14px;\
font-family: 'Source Code Pro', 'Courier New', monospace;\
border-right: 1px dotted #e0e0e0;\
}\
.ace-sashido .ace_gutter-cell {\
display: flex;\
align-items: center;\
justify-content: flex-end;\
padding-right: 14px;\
}\
.ace-sashido .error-on-line {\
color: #ed2655;\
font-weight: 700;\
}\
.ace-sashido .ace_error {\
background: none;\
}\
.ace-sashido .ace_tooltip {\
opacity: 0;\
}\
.ace-sashido .ace_print-margin {\
width: 1px;\
background: #e8e8e8\
}\
.ace-sashido .ace_cursor {\
border-left: 2px solid #100011\
}\
.ace-sashido .ace_overwrite-cursors .ace_cursor {\
border-left: 0px;\
border-bottom: 1px solid #100011\
}\
.ace-sashido .ace_marker-layer .ace_selection {\
background: rgba(100, 5, 208, 0.27)\
}\
.ace-sashido.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #f3f2f3;\
}\
.ace-sashido .ace_marker-layer .ace_step {\
background: rgb(198, 219, 174)\
}\
.ace-sashido .ace_marker-layer .ace_bracket {\
border-radius: 0;\
border: none;\
z-index: 0;\
}\
.ace-sashido .ace_marker-layer .ace_bracket:after {\
content: '';\
position: absolute;\
top: 0;\
bottom: 0;\
left: 0;\
right: 0;\
border-radius: 1px;\
background-color: #e0e0e0;\
z-index: 1;\
}\
.ace-sashido .ace_marker-layer .ace_active-line {\
background-color: #f2f2f2;\
}\
.ace-sashido .ace_gutter-active-line {\
background-color: #f2f2f2;\
}\
.ace-sashido .ace_marker-layer .ace_selected-word {\
border: 1px solid rgba(100, 5, 208, 0.27)\
}\
.ace-sashido .ace_invisible {\
color: #e0e0e0;\
}\
.ace-sashido .ace_invisible_eol {\
display: none;\
}\
.ace-sashido .ace_fold:hover {\
background: none;\
}\
.ace-sashido .ace_fold {\
color: #0092ff;\
vertical-align: inherit;\
background: none;\
border: none;\
}\
.ace-sashido .ace_fold-widget {\
width: 14px;\
margin: 0 -14px 0 0;\
position: relative;\
background: none;\
border: none;\
}\
.ace-sashido .ace_fold-widget:before {\
background: none;\
border: none;\
}\
.ace-sashido .ace_fold-widget:before {\
content: '';\
position: absolute;\
top: 50%;\
left: 50%;\
height: 0;\
width: 0;\
border-style: solid;\
}\
.ace-sashido .ace_open:before {\
border-width: 3px 3px 0 3px;\
border-color: #a3a3c2 transparent transparent;\
margin: -2px 0 0 -4px;\
}\
.ace-sashido .ace_closed:before {\
border-width: 3px 0 3px 3px;\
border-color: transparent transparent transparent #0092ff;\
margin: -3px 0 0 -2px;\
}\
.ace-sashido .ace_keyword {\
color: #674Aa8;\
rbackground-color: rgba(163, 170, 216, 0.055)\
}\
.ace-sashido .ace_constant.ace_language {\
color: #7D7e52;\
rbackground-color: rgba(189, 190, 130, 0.059)\
}\
.ace-sashido .ace_constant.ace_numeric {\
color: rgba(79, 130, 123, 0.93);\
rbackground-color: rgba(119, 194, 187, 0.059)\
}\
.ace-sashido .ace_constant.ace_character,\
.ace-sashido .ace_constant.ace_other {\
color: rgba(2, 95, 105, 1.0);\
rbackground-color: rgba(127, 34, 153, 0.063)\
}\
.ace-sashido .ace_support.ace_function {\
color: #9D7e62;\
rbackground-color: rgba(189, 190, 130, 0.039)\
}\
.ace-sashido .ace_support.ace_class {\
color: rgba(239, 106, 167, 1.0);\
rbackground-color: rgba(239, 106, 167, 0.063)\
}\
.ace-sashido .ace_storage {\
color: rgba(123, 92, 191, 1.0);\
rbackground-color: rgba(139, 93, 223, 0.051)\
}\
.ace-sashido .ace_invalid {\
color: #DFDFD5;\
rbackground-color: #CC1B27\
}\
.ace-sashido .ace_string {\
color: #0e9ee7;\
rbackground-color: rgba(170, 175, 219, 0.035)\
}\
.ace-sashido .ace_comment {\
font-style: italic;\
color: rgba(64, 79, 80, 0.67);\
rbackground-color: rgba(95, 15, 255, 0.0078)\
}\
.ace-sashido .ace_entity.ace_name.ace_function,\
.ace-sashido .ace_variable {\
color: #455867;\
rbackground-color: rgba(34, 255, 73, 0.12)\
}\
.ace-sashido .ace_boolean.ace_language {\
  color: #ed2655;\
}\
.ace-sashido .ace_variable.ace_language {\
color: #316fcf;\
rbackground-color: rgba(58, 175, 255, 0.039)\
}\
.ace-sashido .ace_variable.ace_parameter {\
font-style: italic;\
color: rgba(51, 150, 159, 0.87);\
rbackground-color: rgba(5, 214, 249, 0.043)\
}\
.ace-sashido .ace_entity.ace_other.ace_attribute-name {\
color: rgba(73, 70, 194, 0.93);\
rbackground-color: rgba(73, 134, 194, 0.035)\
}\
.ace-sashido .ace_entity.ace_name.ace_tag {\
color: #3976a2;\
rbackground-color: rgba(73, 166, 210, 0.039)\
}";

    var dom = acequire("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass);
});
